<template>
  <div class="activities">
    <div class="title">
      <div></div>
      意见反馈
    </div>
    <div class="query">
      <div class="query-box">
        <span>查询</span>
        <el-input v-model="query" placeholder="用户昵称"></el-input>
      </div>
     <el-button type="primary" @click="inquire">查询</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>

        <el-table-column align="center" prop="name" label="用户头像">
           <template slot-scope="images">
            <el-image
              style="width: 50px; height: 50px"
              class="table-td-thumb"
              :src="images.row.headImage"
              :preview-src-list="[images.row.headImage]"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="userName" label="用户昵称">
        </el-table-column>

        <el-table-column align="center" prop="content" label="内容">
        </el-table-column>

        <el-table-column align="center" prop="createTime" label="创建时间">
        </el-table-column>
    
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import local from "@/utils/local.js";
import { findComplaintAll } from "@/api/api";
export default {
  data() {
    return {
      //  activityId: "",
      ruleList: [],
      query: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      adminId: "",
    };
  },
  created() {
    this.adminId = local.get("id");
    this.getList();
  },
  methods: {

    //  获取banner列表
    async getList() {
      let res = await findComplaintAll({
        query: this.query,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      });
      console.log(res);
      let { data } = res;
      //边界判断
      if (!data.itemList.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
      this.tableData = data.itemList;
      console.log(this.tableData, 9898);
      this.total = data.totalSize;
    },
    // 查询
    inquire() {
      this.getList();
    },
    // 刷新
    refresh() {
      this.query = "";
      this.getList();
    },

    open() {
      const h = this.$createElement;
      this.$msgbox({
        title: "消息",
        message: h("p", null, [
          h("span", null, "内容可以是 "),
          h("i", { style: "color: teal" }, "VNode"),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            setTimeout(() => {
              done();
              setTimeout(() => {
                instance.confirmButtonLoading = false;
              }, 300);
            }, 3000);
          } else {
            done();
          }
        },
      }).then((action) => {
        this.$message({
          type: "info",
          message: "action: " + action,
        });
      });
    },
    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
</style>